import {Image} from "../Image/Image";
import React from "react";
import status from "../../data/status.json";
import {getCountryName, getLink} from "../Property/PropertyHelper";

function PromotionCard({promotion}) {
    const link = getLink(promotion, true);

    let numProperties = 0;
    let numAvailableProperties = 0;

    for(const building of promotion.buildings){
        for(const property of building.properties){
            numAvailableProperties += (property.status === "active" ? 1 : 0);
            numProperties++;
        }
    }

    return (
        <article className="flex justify-center group cursor-pointer text-primary"
                 onClick={() => window.location.href = link}>
            <div className="relative w-full">
                <div className="z-20 text-xs p-2 top-0 right-0 absolute bg-neutral-700 text-white">
                    <p className="uppercase">promotion |
                        réf. <strong>{promotion.ref}</strong></p>
                </div>
                {promotion.status !== "active" ? (
                        <div
                            className="absolute uppercase bg-red-500 bg-opacity-70 w-full py-1 bottom-[40%] md:bottom-1/3 text-center text-white font-bold z-20">
                            {status[promotion.status]}
                        </div>
                    )
                    : ""}
                <div className="bg-white w-full h-[30rem] flex flex-col">
                    <div className="z-10 h-3/5 md:h-2/3">
                        <div className="h-full w-full overflow-hidden">
                            <Image size="lg"
                                   className="h-full w-full object-cover group-hover:scale-110 transition-transform"
                                   src={promotion?.attachments[0]?.url}
                                   alt={promotion.title.replace(/ de [0-9](,[0-9])+ pièces/gm, "")} />
                        </div>
                    </div>
                    <div className="flex flex-col justify-between pt-2 h-2/5 md:h-1/3">
                        <div className="flex justify-between flex-col md:flex-row gap-2">
                            <a href={link} className="font-bold place-self-start text-xl line-clamp-2">
                                {promotion.title.replace(/ de [0-9](,[0-9])+ pièces/gm, "")}
                            </a>
                        </div>
                        <div>
                            <div className="flex flex-col gap-2">
                                <p>{promotion.postalCode} {promotion.locality}, {promotion.region}, {promotion.country === "CH" ? "Suisse" : getCountryName(promotion.country)}</p>
                                <div className="flex gap-x-2 divide-x-[1px] divide-primary">
                                    Promotion de {numProperties} bien{numProperties > 1 ? "s" : ""}
                                    {numAvailableProperties > 0 ? (numAvailableProperties < numProperties ? " (plus que " : " (") + numAvailableProperties + " bien" + (numAvailableProperties > 1 ? "s" : "") + " disponible" + (numAvailableProperties > 1 ? "s)" : ")") : ""}
                                </div>
                                <p className="font-bold underline hover:text-primary-light w-fit">Plus de détails</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </article>
    )
}

export default PromotionCard;